import Navbar from "../components/Navbar";
import WelcomeToFt from "../components/WelcomeToFt";
import WhyFt from "../components/WhyFt";
import HeaderSlider from "../components/HeaderSlider";
import Footer from "../components/Footer";
import TestimonialComponent from "../components/TestimonialComponent";
import GroomingPackageComponent from "../components/GroomingPackageComponent";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import OurLocation from "../components/OurLocation";
import HowFt from "../components/HowFt";

import { Helmet } from "react-helmet";
// import KeyWords from "../components/KeyWords";
import ClientSaysComponent from "../components/ClientSaysComponent";
import ScrollNavbar from "../components/ScrollNavbar";
import CustomerFeedback from "../components/main/CustomerFeedback";

const HomePage = () => {
  return (
    <div>
      
      <Helmet>
        <title>FluffyTouch™ | Premium At-Home Pet Grooming Services</title>
        <meta
          name="description"
          content="India's trusted at-home pet grooming! Certified groomers come to you for baths, haircuts & spa treatments. Same-day slots. 30% OFF first booking"
        />
      </Helmet>


      <ScrollNavbar/>


      {/* <ContactFixButton /> */}

      <Navbar />
      <HeaderSlider />
      <NumberIncrement />
      <WelcomeToFt />
      <ClientSaysComponent/>
      <GroomingPackageComponent />
      <ExploreGroomingService />
      {/* <PetBoardingComponent /> */}
      <WhyFt />
      <OurLocation />
      <HowFt /> 
      <div className="ft-customer-reviews-new-container">
      <CustomerFeedback  viewMoreValue="active" />
      </div>
      {/* <TestimonialComponent /> */}
      {/* <KeyWords /> */}
      <Footer />
    </div>
  );
};

export default HomePage;
